import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

export interface NavMenuConfig {
  id:         string;
  sort_order: number;
  enabled:    boolean;
}

export function useNavMenu(): NavMenuConfig[] | null {
  const [config, setConfig] = useState<NavMenuConfig[] | null>(null);

  useEffect(() => {
    supabase
      .from('nav_menu_config')
      .select('id, sort_order, enabled')
      .order('sort_order')
      .then(({ data }) => setConfig(data ?? []));
  }, []);

  return config;
}
